import { createAppSlice } from 'app/createAppSlice'

const initialState = {
  lastScan: null, // { type, value, timestamp }
  scanStatus: 'idle', // 'idle' | 'processing' | 'success' | 'error'
  errorMessage: '',
  showDetailModal: false,
  parsedDetail: null,
}

export const scannerSlice = createAppSlice({
  name: 'scanner',
  initialState,
  reducers: (create) => ({
    setScanResult: create.reducer((state, { payload }) => {
      state.lastScan = {
        type: payload.type,
        value: payload.value,
        timestamp: Date.now(),
      }
      state.errorMessage = ''
    }),
    setScanStatus: create.reducer((state, { payload }) => {
      state.scanStatus = payload.status
      if (payload.errorMessage) {
        state.errorMessage = payload.errorMessage
      }
    }),
    clearScan: create.reducer((state) => {
      state.lastScan = null
      state.scanStatus = 'idle'
      state.errorMessage = ''
      state.showDetailModal = false
      state.parsedDetail = null
    }),
    setShowDetailModal: create.reducer((state, { payload }) => {
      state.showDetailModal = payload
    }),
    setParsedDetail: create.reducer((state, { payload }) => {
      state.parsedDetail = payload
    }),
  }),
})

export const {
  setScanResult,
  setScanStatus,
  clearScan,
  setShowDetailModal,
  setParsedDetail,
} = scannerSlice.actions

export default scannerSlice.reducer
